import { useEffect, useState } from 'react';

const STATUS_CLOCK_INTERVAL_MS = 10_000;

export function useLocationStatusClock() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = window.setInterval(
      () => setNow(Date.now()),
      STATUS_CLOCK_INTERVAL_MS,
    );

    return () => window.clearInterval(interval);
  }, []);

  return now;
}
